import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetPositionOrgChartList } from "../Responses/GetPositionOrgChartList";

export async function getPositionOrgChartList(data) {
	let response = await getAPIResponse("/v1/positionOrgChart-list", data);
	if (response === null) {
		return null;
	}
	let getPositionOrgChartList = GetPositionOrgChartList.createFromResponseData(response);
	return getPositionOrgChartList;
}